<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="pageTitle"
      [class]="extraClass"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (loaded) {
      @if (!params?.address?.address_name) {
        <tidy-row [align]="'center'">
          <tidy-text
            [header]="'For '" />
          <tidy-text
            [header]="params?.address?.address1"
            [translate]="false" />
          <tidy-text
            [header]="params?.address?.address2 !== null ? ' ' + params?.address?.address2 : ''"
            [translate]="false" />
        </tidy-row>
      }
      @if (params?.address?.address_name) {
        <tidy-row [align]="'center'">
          <tidy-text
            [header]="'For '"
            [translate]="false" />
          <tidy-text
            [header]="params?.address?.address_name"
            [translate]="false" />
        </tidy-row>
      }
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'How do you want to book?'" />
      </tidy-row>
      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }
      @if (scenario === 'notHasCleaningPros' || scenario === 'notHasNonCleaningPros') {
        @if (scenario === 'notHasNonCleaningPros') {
          <tidy-card>
            <tidy-card-button (action)="goToRequestJob()">
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/icon/searching.svg'"
                  class="title-size" />
                <tidy-text
                  [header]="'Request '" />
                <tidy-text
                  [header]="params?.categoryHeader" />
              </tidy-row>
              <tidy-row class="extra-top-padding">
                <tidy-text
                  [body]="priorityListSentence" />
              </tidy-row>
            </tidy-card-button>
          </tidy-card>
        }
        @if (scenario !== 'notHasNonCleaningPros') {
          <tidy-card>
            <tidy-card-button (action)="goToBookJobwithNewPro()">
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/book-job.svg'"
                  class="title-size" />
                <tidy-text
                  [header]="'Book '" />
                <tidy-text
                  [header]="params?.categoryHeader" />
              </tidy-row>
            </tidy-card-button>
          </tidy-card>
        }
        <tidy-card>
          <tidy-card-button (action)="goToBrowsePros()">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/icon/thumbtack_icon.png'"
                class="title-size" />
              <tidy-text
                [header]="'Browse Pros'" />
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
        <tidy-card>
          <tidy-card-button (action)="goToAddPro()">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/priority.svg'"
                class="title-size" />
              <tidy-text
                [header]="'Add Pro'" />
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
      }
      @if (scenario === 'hasCleaningPros' || scenario === 'hasNonCleaningPros') {
        <tidy-card>
          <tidy-card-button (action)="goToRequestJob()">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/icon/searching.svg'"
                class="title-size" />
              <tidy-text
                [header]="'Request '" />
              <tidy-text
                [header]="params?.categoryHeader" />
            </tidy-row>
            <tidy-row class="extra-top-padding">
              <tidy-text
                [body]="priorityListSentence" />
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
        <tidy-row>
          <tidy-text
            [body]="'Want a specific pro?'" />
        </tidy-row>
        @for (pro of shownPros; track pro) {
          <tidy-card>
            <tidy-card-button (action)="goToBookJobWithPro(pro)">
              <tidy-row class="vertical-align-center">
                <tidy-initials-icon
                  [fullName]="pro?.object?.first_name" />
                <tidy-text
                  [header]="pro?.object?.first_name" />
              </tidy-row>
            </tidy-card-button>
          </tidy-card>
        }
        @if (pros?.length > 2 && pros?.length !== shownPros?.length) {
          <tidy-row [align]="'center'">
            <tidy-text
              [body]="'View More'"
              class="link"
              (action)="showAllPros()" />
          </tidy-row>
        }
        <tidy-row>
          <tidy-text
            [body]="'Want a new pro?'" />
        </tidy-row>
        @if (scenario === 'hasCleaningPros') {
          <tidy-card>
            <tidy-card-button (action)="goToBookJobwithNewPro()">
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/book-job.svg'"
                  class="title-size" />
                <tidy-text
                  [header]="'Instantly Book a New Pro'" />
              </tidy-row>
            </tidy-card-button>
          </tidy-card>
        }
        <tidy-card>
          <tidy-card-button (action)="goToBrowsePros()">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/browse-pros.svg'"
                class="title-size" />
              <tidy-text
                [header]="'Browse Pros'" />
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
